export enum SortOrder {
    ALPHABETICAL = 'ALPHABETICAL',
    NONE = 'NONE'
}
